import Http from '@/http/bhiotrack';
import { serialize } from '@/utils';

const registerClient = async (clientData) => {
  const { data } = await Http.post('/user', clientData);
  return data;
};

const getAllClients = async (params = {}) => {
  const { data } = await Http.get(`/user${serialize(params)}`);
  return data;
};

const getClient = async () => {
  const { data } = await Http.get(`/user`);
  return data;
};

const updateClient = async (cpf, clientData) => {
  const { data } = await Http.put(`/user/${cpf}`, clientData);
  return data;
};

const deleteClient = async (cpf) => {
  const { data } = await Http.delete(`/user/${cpf}`);
  return data;
};

export default {
  registerClient,
  getAllClients,
  getClient,
  updateClient,
  deleteClient,
};
